import axios from 'axios';
import AuthService from '@/services/AuthService';

const baseUrl = `${process.env.VUE_APP_API_BASEURL}/VotingRegistrations`;

export default {
  getHeaders() {
    const _headers = {
      'Content-Type': 'application/json',
      Authorization: `${AuthService.getAuthHeader()}`,
    };
    return _headers;
  },
  getVotingRegistrations(status) {
    const url = `${baseUrl}?status=${status}`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .get(url, { headers: this.getHeaders() })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  getVotingRegistration(id) {
    const url = `${baseUrl}/${id}`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .get(url, { headers: this.getHeaders() })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  verifyRegistration(id) {
    const url = `${baseUrl}/${id}/verify`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(url, null, { headers: this.getHeaders() })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  approveRegistration(id) {
    const url = `${baseUrl}/${id}/approve`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(url, null, { headers: this.getHeaders() })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  denyRegistration(id) {
    const url = `${baseUrl}/${id}/deny`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(url, null, { headers: this.getHeaders() })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  downloadPdf(id) {
    const url = `${baseUrl}/${id}/pdf`;
    return new Promise((resolve, reject) => {
      return (
        axios({
          url,
          method: 'GET',
          responseType: 'blob',
          headers: this.getHeaders(),
        })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
};
